/* eslint-disable camelcase */
import smartTrim from './wordsRemove';

export const SEO_SUFFIX_PT = 'Desenvolvimento de Apps e Software com IA - Juiz de Fora/MG';
export const SEO_SUFFIX_EN = 'App and Software Development with AI - Brazil';

const DEFAULT_SITE_URL = 'http://localhost:3000';

const normalizeSiteUrl = (siteUrl?: string) => (siteUrl || DEFAULT_SITE_URL).replace(/\/+$/, '');

const buildLocalizedUrl = (siteUrl: string, locale: string, pathname: string) => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const localizedPath =
    normalizedPath.startsWith(`/${locale}/`) || normalizedPath === `/${locale}`
      ? normalizedPath
      : `/${locale}${normalizedPath}`;

  return new URL(localizedPath, `${siteUrl}/`).toString();
};

export const SEO = (SEOProps: {
  pathname: string;
  locale: string;
  title?: string;
  defaultTitle?: {
    enTitle?: string;
    ptTitle?: string;
  };
  hideAppMastersTitle?: boolean;
  description?: string;
  image?: string;
}) => {
  const siteUrl = normalizeSiteUrl(process.env.NEXT_PUBLIC_SITE_URL);
  const url = buildLocalizedUrl(siteUrl, SEOProps.locale, SEOProps.pathname);

  const isEn = SEOProps.locale === 'en';

  const metaTitle =
    SEOProps.title || SEOProps.defaultTitle
      ? SEOProps.title
        ? `${SEOProps.title}${
            !!SEOProps.hideAppMastersTitle
              ? ''
              : ` - App Masters - ${isEn ? SEO_SUFFIX_EN : SEO_SUFFIX_PT}`
          }`
        : isEn
          ? `${SEOProps.defaultTitle?.enTitle}${
              !!SEOProps.hideAppMastersTitle ? '' : ` - App Masters - ${SEO_SUFFIX_EN}`
            }`
          : `${SEOProps.defaultTitle?.ptTitle}${
              !!SEOProps.hideAppMastersTitle ? '' : ` - App Masters - ${SEO_SUFFIX_PT}`
            }`
      : null;

  return {
    ...(metaTitle && { title: metaTitle }),
    ...(SEOProps.description && { description: smartTrim(SEOProps.description, 165, ' ', '...') }),
    canonical: url,
    openGraph: {
      type: 'website',
      locale: SEOProps.locale,
      url: url,
      site_name: 'App Masters',
      images: [
        {
          url: SEOProps.image || `${siteUrl}/appmasters-metaimage.png`,
          width: 800,
          height: 600,
        },
      ],
    },
  };
};

export const breadcrumbTitle = (title: string, isEn: boolean, hideAppMastersTitle?: boolean) =>
  hideAppMastersTitle ? title : `${title} - App Masters - ${isEn ? SEO_SUFFIX_EN : SEO_SUFFIX_PT}`;

export const additionalLinkTags = (paths: [path1: string, path2: string]) => {
  const siteUrl = normalizeSiteUrl(process.env.NEXT_PUBLIC_SITE_URL);
  return paths.map((path, i) => {
    const locale = i === 0 ? 'pt' : 'en';
    return {
      rel: 'alternate',
      href: buildLocalizedUrl(siteUrl, locale, path),
      hrefLang: locale,
    };
  });
};
